module.exports = __webpack_public_path__ + "img/logo.196bc503.svg";